// extracted by mini-css-extract-plugin
export default {"container":"loader_container__FKRIs","fadein":"loader_fadein__VgOFs","loader":"loader_loader__T9V9K","load7":"loader_load7__tzeFr"};